import { render, staticRenderFns } from "./BatchCreateModal.vue?vue&type=template&id=83804b28&scoped=true"
import script from "./BatchCreateModal.vue?vue&type=script&lang=js"
export * from "./BatchCreateModal.vue?vue&type=script&lang=js"
import style0 from "./BatchCreateModal.vue?vue&type=style&index=0&id=83804b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83804b28",
  null
  
)

export default component.exports